import { z } from 'zod';

import type { IdSalesUnitDto } from '@/services/ws-companies/src/main/resources/rest-api';

export interface EmailTemplateFormRouteParams {
  emailTemplateId: string | undefined;
}

export enum EmailTemplateFormSearchKey {
  SALES_UNIT_ID = 'salesUnitId',
}

export const EmailTemplateFormSearchParams = z.object({
  [EmailTemplateFormSearchKey.SALES_UNIT_ID]: z.custom<IdSalesUnitDto>().optional(),
});
export type EmailTemplateFormSearchParams = z.infer<typeof EmailTemplateFormSearchParams>;
